const a = {
  MOBILE: 640,
  TABLET: 768
}, o = (t) => {
  const e = t.getFullYear(), r = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0");
  return `${e}-${r}-${n}`;
}, g = (t, e) => {
  let r;
  return () => {
    clearTimeout(r), r = setTimeout(t, e);
  };
};
export {
  a as D,
  o as S,
  g as _
};
